<template>
  <div>
    <search-nav @handleSearch="handleClickSearch">
      <search-nav-item-select name="year" label="연도" v-model="nav.searchYear" :list="selectYearOptions" />
      <!-- <search-nav-item-select name="type" label="구분" v-model="nav.searchType" :list="searchTypes" />
      <search-nav-item-select name="typefilter" label="" v-model="nav.searchTypeFilter" :list="searchTypeFilters" style="width: 300px !important" /> -->
    </search-nav>
    <vx-card>
      <h5 class="mb-4"><i class="dot"></i> 안전보건 교육 미이행 세부 현황</h5>
      <vs-tabs v-if="1 < tabOptions.length" :value="tabIndex"> <vs-tab v-for="(tab, tab_i) in tabOptions" :key="`tab_${tab_i}_${tab.value}`" :label="tab.text" @click="moveTab(tab.value)"></vs-tab></vs-tabs>
      <!-- CONTENT -->
      <div class="content-container">
        <!-- HEAD -->
        <div class="flex items-center justify-start gap-2 mb-3">
          <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
            <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
          </vs-select>
          <FilterButton
            :typeOptions="['기계공학과', '토목공학과', '건축공학과', '법학과', '기타']"
            :addOptions="['정기안전교육', '채용시 안전교육']"
            :value="nav.filter"
            @input="filterButtonInput"
          />

          <SearchNavItemKeyword :viewLabel="true" label="학교(기관)명" v-model="nav.searchKeyword" class="ml-auto" />
        </div>
        <!-- TABLE -->
        <table>
          <colgroup>
            <col width="100" />
            <col width="210" />
            <col width="350" />
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th>구분</th>
              <th>학교(기관)명</th>
              <th v-show="nav.currentTab === 'all' || nav.currentTab === '정기안전교육'">정기안전교육</th>
              <th v-show="nav.currentTab === 'all' || nav.currentTab === '채용시 안전교육'">채용시 안전교육</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, row_i) in renderTableDatas" :key="row_i">
              <td>{{ (nav.currentPage - 1) * nav.perPage + row_i + 1 }}</td>
              <td>{{ row.category }}</td>
              <td>{{ row.label }}</td>
              <td v-show="nav.currentTab === 'all' || nav.currentTab === '정기안전교육'"><ColorCircleData :value="3 < row['정기안전교육']" :label="`${row['정기안전교육']}회/4회`" /></td>
              <td v-show="nav.currentTab === 'all' || nav.currentTab === '채용시 안전교육'"><ColorCircleData :value="3 < row['채용시 안전교육']" :label="`${row['채용시 안전교육']}회/4회`" /></td>
            </tr>
            <tr v-if="renderTableDatas.length === 0">
              <td :colspan="nav.currentTab === 'all' ? 5 : 4">표시할 데이터가 없습니다.</td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATION -->
        <div class="vs-con-table mt-10">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="nav.total" :perPage="nav.perPage" :max-items="5" v-model="nav.currentPage"></k-pagination>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import FilterButton from "./components/FilterButton/FilterButton.vue";
import ColorCircleData from "./components/ColorCircleData.vue";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";

export default {
  name: "GraphDetailHealthSafetyEducationNotPerformedChart",
  components: {
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    FilterButton,
    ColorCircleData,
    KPagination,
  },
  data() {
    return {
      nav: {
        currentTab: "all",

        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{ type: "type", value: ["기계공학과", "토목공학과", "건축공학과", "법학과", "기타"] }],

        perPage: 50,
        currentPage: 1,
        total: 0,
      },
      searchTypes: [{ value: "전체" }, { value: "반기" }, { value: "분기" }, { value: "월" }, { value: "일" }],
      tabIndex: 0,
      apiData: [],
      talbeDatas: [],
      renderTableDatas: [],
    };
  },
  computed: {
    // 선택 가능한 연도 값은 2020년부터 내년까지
    selectYearOptions() {
      const years = [];
      const startYear = 2020;
      const endYear = new Date().getFullYear() + 1;
      for (let i = startYear; i <= endYear; i++) {
        years.push(i);
      }
      return years.reverse().map((year) => ({ value: year }));
    },
    searchTypeFilters() {
      let returnData = [{ value: "전체" }];

      if (this.nav.searchType === "반기") returnData = [{ value: "상반기" }, { value: "하반기" }];
      else if (this.nav.searchType === "분기") returnData = [{ value: "1분기" }, { value: "2분기" }, { value: "3분기" }, { value: "4분기" }];
      else if (this.nav.searchType === "월") {
        // 1~12월
        const months = [];
        for (let i = 1; i <= 12; i++) {
          months.push(i);
        }
        returnData = months.map((month) => ({ value: `${month}월` }));
      } else if (this.nav.searchType === "일") {
        // 1~31일
        const days = [];
        for (let i = 1; i <= 31; i++) {
          days.push(i);
        }
        returnData = days.map((day) => ({ value: `${day}일` }));
      }

      if (returnData.length > 0) this.nav.searchTypeFilter = returnData[0].value;
      return returnData;
    },
    // Content Tab Items
    tabOptions() {
      return [
        { text: "전체", value: "all" },
        { text: "정기안전교육", value: "정기안전교육" },
        { text: "채용시 안전교육", value: "채용시 안전교육" },
      ];
    },
    perPageOpstions() {
      return [50, 75, 100, 125, 150];
    },
  },
  watch: {
    "nav.searchKeyword"(value) {
      console.log("searchKeyword", value);
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.perPage"(/*value*/) {
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    "nav.currentPage"(value) {
      // console.log("!!!", value);
      this.setRenderTableData();
    },
    "nav.searchYear"(value) {
      console.log("searchYear", value);
      this.$set(this.nav, "currentPage", 1);
      this.loadAPI();
    },
  },
  created() {
    this.loadAPI();
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      this.setTableData();
    },
    filterButtonInput(data) {
      this.nav.filter = data;
      if (this.nav.currentPage !== 1) this.$set(this.nav, "currentPage", 1);
      else this.setRenderTableData();
    },
    // 탭 이동
    moveTab(data) {
      this.nav.currentTab = data;
    },
    async loadAPI() {
      this.apiData = await this.$store.dispatch("summary/LOAD_FIELD_EDUCATION_NOT_PERFORMED_HS", {
        projectIds: [6],
        dateBegin: `${this.nav.searchYear}-01-01 00:00:00`,
        dateEnd: `${this.nav.searchYear}-12-31 23:59:59`,
      });
      console.log('dfdfd', this.apiData);
      this.setTableData();
    },
    setTableData() {
      this.talbeDatas = [];

      // this.apiData.fields 내용을 field_name 기준으로 오름차순 정렬한다
      this.apiData.fields = this.apiData.fields.sort((a, b) => {
        if (a.field_name < b.field_name) return -1;
        if (a.field_name > b.field_name) return 1;
        return 0;
      });

      const notPerformedFieldIds = this.apiData.notPerformedFieldIds;
      if (notPerformedFieldIds && notPerformedFieldIds.all[this.nav.searchYear]) {
        // 선택한 연도의 Field Ids를 가져온다
        // const filterYearField = this.apiData.fields.filter((field) => notPerformedFieldIds.all[this.nav.searchYear][0].includes(field.id));

        const _talbeDatas = this.apiData.fields.map((data) => {
          // 만약 data.facility_category.cat3가 facilityCategories에 포함되지 않으면 "기타"로 설정한다
          const facilityCategories = ["기계공학과", "토목공학과", "건축공학과", "법학과"];
          const cat3 = facilityCategories.includes(data.facility_category.cat3) ? data.facility_category.cat3 : "기타";

          return { "id": data.id, "label": data.field_name, "category": cat3, "정기안전교육": 0, "채용시 안전교육": 0 };
        });

        for (const key in notPerformedFieldIds) {
          if (key === "all") continue;
          else if (notPerformedFieldIds[key][this.nav.searchYear]) {
            _talbeDatas.map((data, data_i) => {
              for (let _i = 1; _i <= 12; _i++) {
                if (notPerformedFieldIds[key][this.nav.searchYear][_i].includes(data.id)) _talbeDatas[data_i][key] += 1;
              }
            });
          }
        }

        this.talbeDatas = _talbeDatas;
        this.setRenderTableData();
      }
    },
    setRenderTableData() {
      console.log("SET RENDER TABLE DATA");
      let datas = this.talbeDatas;

      for (const fd of this.nav.filter) {
        if (fd.type === "type") datas = datas.filter((data) => fd.value.includes(data.category));
        else if (fd.type === "buttons") {
          datas = datas.filter((data) => {
            if (fd.value.selectType === "전체") {
              if (fd.value.buttonInput === "미이행") return data["정기안전교육"] < 4 && data["채용시 안전교육"] < 4;
              else if (fd.value.buttonInput === "이행") return 3 < data["정기안전교육"] && 3 < data["채용시 안전교육"];
            } else {
              let key = fd.value.selectType;
              if (key === "정기안전교육") key = '정기안전교육';
              else if (key === "채용시 안전교육") key = "채용시 안전교육";

              if (fd.value.buttonInput === "미이행") return data[key] < 4;
              else if (fd.value.buttonInput === "이행") return 3 < data[key];
            }
          });
        }
      }

      if (this.nav.searchKeyword) {
        datas = datas.filter((data) => data.label.includes(this.nav.searchKeyword));
      }

      const _total = Math.ceil(datas.length / this.nav.perPage);
      this.nav.total = _total < 1 ? 1 : _total;

      const perPage = this.nav.perPage;
      const currentPage = this.nav.currentPage;

      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;

      this.renderTableDatas = datas.slice(start, end);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 6px;
  }

  th {
    font-weight: 500;
    background: #fafafa;
    padding: 18px 0;
  }
}
</style>
